import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal, TextArea } from 'ui/styled'
import useRoadmapUpdate from 'apollo/mutations/CarePlan/CAREPLAN_UPDATE'

const IntroductionModal = ({
  value = '',
  visible = false,
  carePlan,
  onClose
}) => {
  const [textValue, setTextValue] = useState(value)
  useEffect(() => setTextValue(value), [value])

  const { onRoadmapUpdate, loading: updateLoading } = useRoadmapUpdate(
    'Introduction was successfully updated'
  )

  const onSave = async () => {
    await onRoadmapUpdate({
      id: carePlan.id,
      attributes: { introduction: textValue }
    })
    onClose()
  }

  return (
    <Modal
      open={visible}
      title="Care Plan Introduction"
      onCancel={onClose}
      onOk={onSave}
      okButtonProps={{ loading: updateLoading }}
    >
      Text visible on the Care Plan
      <TextArea
        value={textValue}
        onChange={e => setTextValue(e.target.value)}
        maxLength={155}
        showCount
        autoFocus
      />
    </Modal>
  )
}

IntroductionModal.propTypes = {
  value: PropTypes.string,
  carePlan: PropTypes.object,
  visible: PropTypes.bool,
  onClose: PropTypes.func
}

export default IntroductionModal
